import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import PageHeader from '../PageHeader';
import { LOGO_SIZE } from '../../ui/Logo';
import { APP_ROUTES } from '../../app.config.vars/routes';
import Footer from '../Footer';
const AdminPageLayout = ({ children }) => {
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'admin-panel', children: [_jsx(PageHeader, { logoSize: LOGO_SIZE.FULL, logoLink: APP_ROUTES.adminManageRallies, container: 'admin-container' }), _jsx("div", { className: "page-content", children: _jsx("div", { className: "admin-container", children: children }) })] }), _jsx(Footer, { layout: "admin-panel" })] }));
};
export default AdminPageLayout;
